<template>
  <div class="row p-5">
    <div class="col-12 text-center ">
      <h1 class="text-center">Ops :(</h1>
      <h3 v-if="mode === 'permission'" class="mt-5">
        {{
          is_pt_br
            ? "Seu usuário não tem permissão de acessar essa pagina!"
            : "Your user does not have permission to access this page!"
        }}
      </h3>
      <h3 v-else-if="mode === 'connection'" class="mt-5">
        {{
          is_pt_br
            ? "Não foi possível obter os dados necessários."
            : "Unable to get required data."
        }}
        <br />
        {{
          is_pt_br
            ? "Verifique sua conexão com a internet"
            : "Check your internet connection"
        }}
        !<br />
        <small class="mt-5">
          {{
            is_pt_br
              ? "Caso a conexão seja restabelecida recarregue a pagina. (pressione F5 ou Ctrl + R)"
              : "If the connection is reestablished, reload the page. (press F5 or Ctrl + R)"
          }}
        </small>
      </h3>
      <h3 v-else-if="mode === 'block-not-fond'" class="mt-5">
        {{ is_pt_br ? "Bloco não encontrado." : "Block not found." }}
        <br />
        {{
          is_pt_br
            ? "Verifique se a url do bloco esta correta!"
            : "Check the url if the lock is correct!"
        }}

        <br />
      </h3>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "Exceptions",
  props: ["mode", "route"],
  computed: {
    ...mapGetters("user", ["userId"]),
    is_pt_br() {
      return this.$store.getters.is_pt_br;
    },
  },
  watch: {
    userId() {
      console.log("ARA PRA TA AQUI ==> ", this.userId);
      if (this.userId) {
        this.$router.push({ name: "StoneList" });
      }
      //   if(this.route ? this.permissionUser.get(this.route) : false){
      //     this.$router.push({name: this.route})
      //   }
      //   else{
      //     this.$router.push({name: 'Dashboard'})
      //   }
    },
  },
};
</script>
